export default "__VITE_ASSET__52e75485__"